import React, { useState } from 'react';
import { useStateChangeEffect } from 'ui-components/src/hooks/useStateChangeEffect';

import { FileInput } from 'ui-components/src/components/molecules/FileInput';

import { useAttachmentUpload } from '../../hooks/useAttachmentUpload';
import { UploadScope } from '../../types';
import { FileRow } from '../FileRow';
import { FileUploadActions } from '../FileUploadActions';
import { Container, Files, InputMessage, NoResultsMessage } from './styles';
import { isNumber } from '../../../../util';

export const ListedFilesForm = ({
  scope,
  limit,
  onClose,
  onUploadComplete,
}: ListedFilesFormProps) => {
  const {
    uploadFiles,
    addFiles,
    setFileName,
    removeFile,
    uploadState,
    isUploading,
  } = useAttachmentUpload(scope);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);

  useStateChangeEffect((_, isUploading) => {
    if (!isUploading && onUploadComplete) onUploadComplete();
  }, isUploading);

  const mayAddMoreFiles =
    !isNumber(limit) || (limit && uploadState.length < limit);

  return (
    <Container>
      {mayAddMoreFiles ? (
        <>
          <InputMessage>Max file size 10MB</InputMessage>
          <FileInput
            limit={
              isNumber(limit)
                ? (limit as number) - uploadState.length
                : undefined
            }
            onInput={addFiles}
          />
        </>
      ) : (
        <p>You have added the maximum number of files</p>
      )}
      <Files>
        {uploadState.map((state) => (
          <FileRow
            key={state.id}
            fileState={state}
            disabled={isUploading || uploadedFiles.includes(state.id)}
            onRemove={() => removeFile(state.id)}
            onSetName={(name) => setFileName(state.id, name)}
          />
        ))}
        {!uploadState.length && (
          <NoResultsMessage>
            You can drag and drop your files into the box above or click on it
            to select your files manually
          </NoResultsMessage>
        )}
      </Files>
      <FileUploadActions
        isUploading={isUploading}
        uploadState={uploadState}
        onClose={onClose}
        onUpload={() => {
          setUploadedFiles(uploadState.map((item) => item.id));
          uploadFiles();
        }}
      />
    </Container>
  );
};

export interface ListedFilesFormProps {
  scope: UploadScope;
  limit?: number;
  onClose?: () => void;
  onUploadComplete?: () => void;
}
